import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Menu from '../components/Menu';
import Immutable from 'immutable';
import * as Actions from '../actions';
import { GOTO_NAV, GOTO_SECTION } from '../actions/navigation';
import { trUri } from '../utils';

function mapStateToProps(state, ownProps) {
  const uri = ownProps.location.pathname;
  const universalUri = `/${uri.split('/')[2]}`;
  const lang = state.luraschi.get('lang', 'fr');
  const items = state.luraschi.getIn(['data', 'data']).rest().map(i => i.get('meta'));
  const menuindex = items.findKey(item => trUri(item, lang) === universalUri) || 0;
  const presentation = Immutable.fromJS([{ title: (lang === 'fr') ?
    'Présentation' : 'Presentation', uri: trUri(items.get(menuindex), lang) }]);
  const subitems = state.luraschi
    .getIn(['data', 'data', menuindex + 1, 'data'])
    .rest().map(i => i.get('meta'));
  return {
    items,
    subitems: (subitems.size > 0) ? presentation.concat(subitems) : new Immutable.List(),
    lang,
    menuindex,
    navOnly: state.luraschi.get('navonly'),
    backHomeLabel: state.luraschi.getIn(['data', 'meta', 'backhome', lang]),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
    backHome: () => dispatch({ type: GOTO_NAV }),
    showSection: () => dispatch({ type: GOTO_SECTION }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./common/containers/Menu.js